export const blockTypes = {
  PPTX_TEMPLATE: 'pptxTemplate',
};
